module.exports = __webpack_public_path__ + "static/img/ZHGC.d8361465.png";